<template>
  <div class="unit-malha-routes">
    <!-- Título da seção e ação na mesma linha, com régua fina embaixo -->
    <div class="unit-malha-routes__head">
      <span class="unit-malha-routes__title">
        Destinos de malha (prazo em dias úteis)
        <el-tooltip placement="top">
          <div slot="content">
            Prazo real de entrega desta unidade para cada destino.<br />
            Sem destino cadastrado, não há malha a partir desta unidade.<br />
            Econômico em branco = a rota não atende +Econômico.
          </div>
          <i class="el-icon-info unit-malha-routes__info"></i>
        </el-tooltip>
      </span>
      <el-button
        type="text"
        size="small"
        icon="el-icon-plus"
        :disabled="availableUnits.length === 0"
        @click="$emit('add')"
        >Adicionar destino</el-button
      >
    </div>
    <el-table
      :data="rows"
      size="small"
      style="width: 100%"
      empty-text="Nenhum destino cadastrado"
      :row-key="rowKey"
    >
      <el-table-column label="Destino" min-width="240">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.destinyUnitId"
            filterable
            size="small"
            placeholder="Selecione a unidade"
            style="width: 100%"
            @change="onDestinyChange(scope.row)"
          >
            <el-option
              v-for="unit in optionsFor(scope.row)"
              :key="unit.id"
              :label="unitLabel(unit)"
              :value="unit.id"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="Expresso" align="center">
        <el-table-column label="Capital" width="110" align="center">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.daysExpressCapital"
              :min="0"
              :max="999"
              :controls="false"
              size="small"
              class="unit-malha-routes__days"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="Interior" width="110" align="center">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.daysExpressInterior"
              :min="0"
              :max="999"
              :controls="false"
              size="small"
              class="unit-malha-routes__days"
            ></el-input-number>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="Econômico" align="center">
        <el-table-column label="Capital" width="110" align="center">
          <template slot-scope="scope">
            <el-input-number
              v-if="servesEconomic(scope.row)"
              v-model="scope.row.daysEconomicCapital"
              :min="0"
              :max="999"
              :controls="false"
              size="small"
              class="unit-malha-routes__days"
            ></el-input-number>
            <el-tooltip v-else placement="top" content="Destino não atende +Econômico">
              <span class="unit-malha-routes__muted">—</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="Interior" width="110" align="center">
          <template slot-scope="scope">
            <el-input-number
              v-if="servesEconomic(scope.row)"
              v-model="scope.row.daysEconomicInterior"
              :min="0"
              :max="999"
              :controls="false"
              size="small"
              class="unit-malha-routes__days"
            ></el-input-number>
            <el-tooltip v-else placement="top" content="Destino não atende +Econômico">
              <span class="unit-malha-routes__muted">—</span>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column :label="$t('ativo')" width="80" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.active"></el-switch>
        </template>
      </el-table-column>
      <el-table-column width="60" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            icon="el-icon-delete"
            title="Remover destino"
            @click="remove(scope.$index)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";

const isDays = (value) =>
  value !== null &&
  value !== undefined &&
  value !== "" &&
  Number.isInteger(Number(value)) &&
  Number(value) >= 0;

export default {
  name: "UnitMalhaRoutes",
  props: {
    rows: { type: Array, default: () => [] },
    units: { type: Array, default: () => [] },
    unitId: { type: String, default: "" },
  },
  computed: {
    candidateUnits() {
      return this.units.filter((unit) => unit.id !== this.unitId);
    },
    usedIds() {
      return this.rows.map((row) => row.destinyUnitId).filter(Boolean);
    },
    availableUnits() {
      return this.candidateUnits.filter(
        (unit) => unit.active && !this.usedIds.includes(unit.id)
      );
    },
  },
  methods: {
    rowKey(row) {
      return row._key || row.id;
    },
    unitById(id) {
      return this.units.find((unit) => unit.id === id);
    },
    unitLabel(unit) {
      return `${unit.code} — ${unit.name}${unit.active ? "" : " (inativa)"}`;
    },
    optionsFor(row) {
      return this.candidateUnits.filter(
        (unit) =>
          unit.id === row.destinyUnitId ||
          (unit.active && !this.usedIds.includes(unit.id))
      );
    },
    servesEconomic(row) {
      const unit = this.unitById(row.destinyUnitId);
      return !unit || unit.viewAcronym !== false;
    },
    onDestinyChange(row) {
      if (!this.servesEconomic(row)) {
        row.daysEconomicCapital = null;
        row.daysEconomicInterior = null;
      }
    },
    remove(index) {
      const vm = this;
      const row = vm.rows[index];
      const unit = row ? vm.unitById(row.destinyUnitId) : null;
      const name = unit ? unit.name : "destino";
      vm.$confirm(
        i18n.t("confirmar-eliminacao-registro", { name }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        vm.$emit("remove", index);
      });
    },
    validate() {
      const vm = this;
      for (let i = 0; i < vm.rows.length; i++) {
        const row = vm.rows[i];
        const n = i + 1;
        if (!row.destinyUnitId) {
          return `Destino de malha ${n}: selecione a unidade de destino`;
        }
        if (!isDays(row.daysExpressCapital) || !isDays(row.daysExpressInterior)) {
          return `Destino de malha ${n}: informe o prazo expresso (capital e interior) em dias úteis`;
        }
        if (vm.servesEconomic(row)) {
          const hasCapital = isDays(row.daysEconomicCapital);
          const hasInterior = isDays(row.daysEconomicInterior);
          if (hasCapital !== hasInterior) {
            return `Destino de malha ${n}: informe os dois prazos do econômico ou deixe ambos em branco`;
          }
        }
      }
      const duplicated = vm.usedIds.find(
        (id, index) => vm.usedIds.indexOf(id) !== index
      );
      if (duplicated) return "Unidade de destino repetida na malha";
      return "";
    },
    payload() {
      const vm = this;
      return vm.rows.map((row) => {
        const economic = vm.servesEconomic(row);
        return {
          destinyUnitId: row.destinyUnitId,
          daysExpressCapital: Number(row.daysExpressCapital),
          daysExpressInterior: Number(row.daysExpressInterior),
          daysEconomicCapital:
            economic && isDays(row.daysEconomicCapital) ? Number(row.daysEconomicCapital) : null,
          daysEconomicInterior:
            economic && isDays(row.daysEconomicInterior) ? Number(row.daysEconomicInterior) : null,
          active: row.active !== false,
        };
      });
    },
  },
};
</script>
<style scoped>
.unit-malha-routes__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 8px 0 10px;
  padding-bottom: 4px;
  border-bottom: 1px solid #ebeef5;
}
.unit-malha-routes__title {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #909399;
}
.unit-malha-routes__head >>> .el-button--text {
  padding-top: 4px;
  padding-bottom: 4px;
}
.unit-malha-routes__info {
  margin-left: 4px;
  color: #c0c4cc;
  cursor: help;
  vertical-align: middle;
}
.unit-malha-routes__days {
  width: 100%;
}
.unit-malha-routes__muted {
  color: #c0c4cc;
}
</style>
